import styled from '@emotion/styled'

import { Color } from '../../../../enums/color'
import { Spacing } from '../../../../enums/spacing'

export const DrawerFooterWrapper = styled.footer`
  display: flex;
  padding: ${Spacing.S16} ${Spacing.S24};
  border-top: 1px solid ${Color.Grey100};
`
